"use strict";
require('./menu.ts');
